import React, { useState } from 'react';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { BsPersonCircle } from "react-icons/bs";
import backgroundImage from '../assest/sgu.webp';
import topLeftImage from '../assest/sgu_logo.png';
import topRightImage from '../assest/OAKYA.png';

const EmployeeLogin = () => {
    const [showPassword, setShowPassword] = useState(false);
    const [data, setData] = useState({
        username: "",
        password: ""
    });
    const navigate = useNavigate();

    const handleOnChange = (e) => {
        const { name, value } = e.target;
        setData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const staticCredentials = {
            username: "SGUAdmin",
            password: "8095655888"
            // username: "Admin",
            // password: "12345"
        };

        if (
            data.username === staticCredentials.username &&
            data.password === staticCredentials.password
        ) {
            sessionStorage.setItem('H7Z4L9VD2XK5JW8QRYT6', btoa('ADMIN001'));
            sessionStorage.setItem('K3M8X1JQ5VZ4B7PWTL9', btoa('admin'));
            toast.success("Login successful!");
            navigate('/');
        } else {
            toast.error("Invalid username or password");
        }
    };

    return (
        <section id='login' className="flex flex-col min-h-screen min-w-full justify-center items-center"
            style={{
                backgroundImage: `url(${backgroundImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'bottom',
                height: '100vh'
            }}>

            <div className="absolute top-5 flex justify-between w-full px-4">
                <div className="flex items-center">
                    <img src={topLeftImage} alt="Logo 1" className="h-16 sm:h-20" />
                </div>

                <div className='flex items-center'>
                    <img src={topRightImage} alt="Logo 2" className="h-16" />
                </div>
            </div>

            <div className="flex mt-[100px] items-center justify-center">
                <div className='bg-[#fffcdc] p-5 w-full max-w-xs sm:max-w-md mx-auto shadow-lg rounded-lg'>
                    <div className='w-16 h-16 mx-auto sm:w-20 sm:h-20'>
                        <BsPersonCircle className='w-full h-full' />
                    </div>

                    <h2 className='text-center text-xl sm:text-2xl mb-4'>Oakya SGU Accounts</h2>
                    <p className='text-xs sm:text-sm text-center mb-2'>Please enter your Username and Password to access the admin portal.</p>

                    <form className='pt-6 flex flex-col gap-2' onSubmit={handleSubmit}>
                        <div className='grid'>
                            <label className='text-sm'>Username:</label>
                            <div className='border-black rounded-lg border p-2'>
                                <input
                                    type='text'
                                    placeholder='Enter username'
                                    name='username'
                                    value={data.username}
                                    onChange={handleOnChange}
                                    className='w-full h-full outline-none bg-transparent'
                                    required
                                />
                            </div>
                        </div>

                        <div>
                            <label className='text-sm'>Password:</label>
                            <div className='border border-black rounded-lg p-2 flex'>
                                <input
                                    type={showPassword ? "text" : "password"}
                                    placeholder='Enter password'
                                    value={data.password}
                                    name='password'
                                    onChange={handleOnChange}
                                    className='w-full h-full outline-none bg-transparent'
                                    required
                                />
                                <div className='cursor-pointer text-xl' onClick={() => setShowPassword((prev) => !prev)}>
                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                </div>
                            </div>
                        </div>

                        <button className='bg-red-600 hover:bg-red-700 text-white px-4 py-2 w-full max-w-[150px] rounded-full hover:scale-110 transition-all mx-auto block mt-6'>
                            Login
                        </button>
                    </form>
                </div>
            </div>
        </section>
    );
};

export default EmployeeLogin;
